angular.module('orderByCz', [])

.filter('orderByCz', ["$parse", function ($parse) {
	function isArrayLike(obj) {
		if (obj === null || isWindow(obj)) {
			return false;
		}

		var length = obj.length;

		if (obj.nodeType === 1 && length) {
			return true;
		}

		return angular.isString(obj) || angular.isArray(obj) || length === 0 ||
		typeof length === 'number' && length > 0 && (length - 1) in obj;
	}

	function isWindow(obj) {
		return obj && obj.document && obj.location && obj.alert && obj.setInterval;
	}

	function map(obj, iterator, context) {
		var results = [];
		angular.forEach(obj, function(value, index, list) {
			results.push(iterator.call(context, value, index, list));
		});
		return results;
	}

	function toBoolean(value) {
		if (typeof value === 'function') {
			value = true;
		} else if (value && value.length !== 0) {
			var v = angular.lowercase("" + value);
			value = !(v == 'f' || v == '0' || v == 'false' || v == 'no' || v == 'n' || v == '[]');
		} else {
			value = false;
		}
		return value;
	}

	return function(array, sortPredicate, reverseOrder) {

		if (array) {

			if (!(isArrayLike(array))) return array;
			if (!sortPredicate) return array;
			sortPredicate = angular.isArray(sortPredicate) ? sortPredicate: [sortPredicate];
			sortPredicate = map(sortPredicate, function(predicate){
				var descending = false, get = predicate || angular.identity;
				if (angular.isString(predicate)) {
					if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
						descending = predicate.charAt(0) == '-';
						predicate = predicate.substring(1);
					}
					get = $parse(predicate);
					if (get.constant) {
						var key = get();
						return reverseComparator(function(a,b) {
							return compare(a[key], b[key]);
						}, descending);
					}
				}
				return reverseComparator(function(a,b){
					return compare(get(a),get(b));
				}, descending);
			});
			var arrayCopy = [];
			for ( var i = 0; i < array.length; i++) { arrayCopy.push(array[i]); }
				return arrayCopy.sort(reverseComparator(comparator, reverseOrder));
		}

		function comparator(o1, o2){
			for ( var i = 0; i < sortPredicate.length; i++) {
				var comp = sortPredicate[i](o1, o2);
				if (comp !== 0) return comp;
			}
			return 0;
		}

		function reverseComparator(comp, descending) {
			return toBoolean(descending) ? function(a,b){return comp(b,a);}
			: comp;
		}
		
		function compare(v1, v2){
			var t1 = typeof v1;
			var t2 = typeof v2;
			if (t1 == t2) {
				if (t1 == "string") {
					v1 = v1.toLocaleLowerCase();
					v2 = v2.toLocaleLowerCase();
				}
				v1 = v1 === null ? "" : v1.toLocaleString();
				return v1.localeCompare(v2);
			} else {
				return t1.localeCompare(t2);
			}
		}
	};
}]);